var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.catalogProductPage},[_c('UserState'),_vm._v(" "),_c('ProductDetail',{attrs:{"slug":_vm.slug,"variant-slug":_vm.variantSlug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }